import styles from './Audiences.module.css'
import useReveal from '../hooks/useReveal.js'

export default function Audiences() {
  const [ref, visible] = useReveal()

  return (
    <section className={styles.section}>
      <div ref={ref} className={`container ${styles.grid} ${visible ? styles.visible : ''}`}>
        <div className={`${styles.panel} ${styles.employers}`} id="employers">
          <p className={styles.panelKicker}>For employers</p>
          <h2 className={styles.panelHeading}>Stop reading a hundred CVs to find three good ones</h2>
          <p className={styles.panelText}>
            Post a role and get a ranked, recruiter-checked shortlist — usually
            within two working days. Flat fee, no surprises at invoice time.
          </p>
          <ul className={styles.panelList}>
            <li>Role live and matching within the hour</li>
            <li>AI-ranked shortlist, reviewed by a recruiter</li>
            <li>One flat fee per placement, agreed upfront</li>
            <li>Direct line to your recruiter, not a call centre</li>
          </ul>
          <a href="#post-role" className={styles.employerCta}>Post a role</a>
        </div>

        <div className={`${styles.panel} ${styles.candidates}`} id="candidates">
          <p className={styles.panelKickerAlt}>For candidates</p>
          <h2 className={styles.panelHeadingAlt}>One profile. Matched to roles that actually fit.</h2>
          <p className={styles.panelTextAlt}>
            Build your profile once. We match you against live roles across
            New Zealand and only get in touch when something's genuinely
            worth your time.
          </p>
          <ul className={styles.panelListAlt}>
            <li>Matched by skills and goals, not just job titles</li>
            <li>Real salary benchmarks for the NZ market</li>
            <li>Straight-talking feedback after every interview</li>
            <li>No recruiter spam — we only reach out when it fits</li>
          </ul>
          <a href="#candidate-signup" className={styles.candidateCta}>Create your profile</a>
        </div>
      </div>
    </section>
  )
}
